import React from 'react'
import {
  Box,
  Typography,
  Accordion,
  makeStyles,
  AccordionSummary,
  AccordionDetails,
} from 'transfix-ui/core'
import { ExpandMoreIcon } from 'transfix-ui/core/icons'
import { brandColors } from 'transfix-ui/theme/colors'
import { Container } from 'components/layout'

const useStyles = makeStyles(() => ({
  accordionDetails: {
    '&.MuiAccordionDetails-root': {
      flexDirection: 'column',
      maxWidth: '800px',
    },
  },
  accordionText: {
    fontSize: '16px',
  },
  bold: {
    fontWeight: 600,
  },
  accordionBase: {
    '&.MuiAccordion-root': {
      boxShadow: 'none',
      borderBottom: `solid ${brandColors.coolGray2}`,
    },
  },
  accordionIcon: {
    color: brandColors.black,
  },
}))

const CarrierScorecardFAQ = () => {
  const classes = useStyles()

  return (
    <div>
      <Container>
        <Typography variant='h3'> Questions? We&apos;ve got answers</Typography>
        <Box mt={3}>
          <Accordion className={classes.accordionBase}>
            <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}>
              <Typography variant='body1' className={classes.bold}>
                How does my carrier rating work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
              <Typography variant='body1'>
                Transfix uses several key performance metrics over your past 50 rolling shipments to
                aggregate your Carrier Score. Here is what goes into a great score:
              </Typography>
              <ul>
                <li className={classes.accordionText}>
                  <b>On-Time Appointments:</b> Percentage of stop pickup and delivery checkin times
                  within 30 minutes of appointment from your last 100 stops.
                </li>
                <li className={classes.accordionText}>
                  <b>Tracking Rate:</b> Percentage of loads that show that tracking was turned on
                  from the Transfix Carrier Mobile App or an integration with ELD such as Motive or
                  Project44.
                </li>
                <li className={classes.accordionText}>
                  <b>Late cancellation:</b> Percentage of shipments that bounced due to an error or
                  incident on your end.
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Accordion className={classes.accordionBase}>
          <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}>
            <Typography variant='body1' className={classes.bold}>
              Why do I want a high Carrier Score?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <p className={classes.accordionText}>
              Your Carrier Score helps Transfix platform to connect you with the best loads and
              lanes available and prioritizes you with our top shippers. Higher scores can also help
              you land dedicated lanes and reserved offers, because we know you’re reliable and
              willing to provide tracking info.
            </p>
            <p className={classes.accordionText}>
              The Transfix algorithm takes Carrier Scores into consideration when you bid, so your
              odds of winning are better with a higher score, even if your bid might be higher than
              others bidding on the same load. Basically, a better score means more money for you.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordionBase}>
          <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}>
            <Typography variant='body1' className={classes.bold}>
              How can I earn an exceptional rating?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol>
              <li className={classes.accordionText}>
                Focus on OTP/OTD times for each stop and keep them within 30 minutes of the
                appointment time. Obviously, things will come up on the route, so be proactive and
                reach out to Transfix via the Carrier Mobile App, phone or email with any issues
                right away so we can note any exceptions that may affect your metrics.
              </li>
              <li className={classes.accordionText}>
                Turn on tracking and keep it on for the entirety of the load – do this for every
                load. Drivers can use the Transfix Carrier mobile app or, you can set up an ELD
                integration.
                {/* <a href='https://transfix.io/'>Here&apos;s how to set it up </a> */}
              </li>
              <li className={classes.accordionText}>
                Try to reduce late cancellations due to poor or inaccurate planning, improper
                documentation, breakdowns/accidents, rejected trailers or issues with drivers, such
                as lack of communication.
              </li>
            </ol>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordionBase}>
          <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}>
            <Typography variant='body1' className={classes.bold}>
              How do I improve my rating?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <p className={classes.accordionText}>
              Transfix automatically monitors three criteria &ndash; on-time appointments, tracking
              rate and late cancellation &ndash; to determine Carrier Scores, so boost those metrics
              and see better scores right away. A score that is not “exceptional” isn&apos;t
              necessarily bad &ndash; you will still receive loads and be able to make money with
              Transfix. Plus, with assessments of a rolling 50-load history, your scores can
              increase quickly as soon as improvements are made.
            </p>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordionBase}>
          <AccordionSummary expandIcon={<ExpandMoreIcon className={classes.accordionIcon} />}>
            <Typography variant='body1' className={classes.bold}>
              What shipments affect my rating?
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <p className={classes.accordionText}>
              Your overall score is based on your most recent 50 shipments with Transfix within the
              past year.
            </p>
          </AccordionDetails>
        </Accordion>
      </Container>
    </div>
  )
}

export default CarrierScorecardFAQ
